<script>
import zohoManuals from "../../helpers/zoho-manuals";
export default {
    name: 'design-2021-help-zoho-tutorials-component',
    data() {
        return {
            manuals: zohoManuals,
            selectedManual: null,
        };
    },
    mounted() {
        this.selectInitialManual();
    },
    methods: {
        selectInitialManual() {
            if (!this.manuals) {
                return;
            }

            if (!this.$authUser.isStudent()) {
                this.selectedManual = this.manuals[0];
            } else {
                this.selectedManual = this.manuals.find((manual) => manual.access === 'student');
            }
        },
    },
    computed: {
        teachersManuals() {
            if (!this.manuals) {
                return null;
            }

            return this.manuals.filter((manual) => manual.access === 'teacher');
        },

        studentsManuals() {
            if (!this.manuals) {
                return null;
            }
            return this.manuals.filter((manual) => manual.access === 'student');
        },
    },
};
</script>

<template>
    <div
        class="apprentice-simple-card zoho-manuals-wrapper"
        v-if="
            ($authUser.isStudent() && studentsManuals.length > 0) ||
            (!$authUser.isStudent() && (studentsManuals.length > 0 || teachersManuals.length > 0))
        ">
        <h3 class="title">{{ $t('help.document_manuals') }}</h3>

        <div class="descriptions">
            {{ $t('help.document_manuals.description') }}
        </div>

        <div class="manuals">
            <ul
                class="teachers manual-links"
                v-if="teachersManuals.length > 0 && !$authUser.isStudent()">
                <li
                    class="header"
                    v-if="teachersManuals.length > 0 && studentsManuals.length > 0 && !$authUser.isStudent()">
                    <h5 class="title">{{ $t('help.document_manuals.teachers_manual_title') }}</h5>
                </li>
                <li
                    class="nav-link"
                    v-for="(manual, index) of teachersManuals"
                    :key="index">
                    <b-link
                        target="_blank"
                        :href="manual.link">
                        <i class="fas fa-external-link-alt"></i>{{ manual.title }}
                    </b-link>
                </li>
            </ul>

            <ul
                class="students manual-links"
                v-if="studentsManuals.length > 0">
                <li
                    class="header"
                    v-if="teachersManuals.length > 0 && studentsManuals.length > 0 && !$authUser.isStudent()">
                    <h5 class="title">{{ $t('help.document_manuals.students_manual_title') }}</h5>
                </li>
                <li
                    class="nav-link"
                    v-for="(manual, index) of studentsManuals"
                    :key="index">
                    <b-link
                        target="_blank"
                        :href="manual.link">
                        <i class="fas fa-external-link-alt"></i>{{ manual.title }}
                    </b-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="scss">
.zoho-manuals-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 2.625rem 5.625rem;

    > .title {
        grid-area: 1 / 1 / 2 / 3;
        margin-bottom: 0;
    }

    .descriptions {
        grid-area: 2 / 1 / 3 / 3;
    }

    .manuals {
        grid-area: 3 / 1 / 4 / 3;
    }
}

.manuals {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: map-get($grid-gutter-spacing, 'forty-two') map-get($grid-gutter-spacing, 'sixty');
}

.manual-links {
    list-style: none;
    padding-left: 0;

    .title {
        margin-bottom: 0;
    }

    li {
        padding: 0.5rem 0;

        &.header {
            margin-bottom: 0;
        }
    }
}

.nav-link {
    a {
        display: flex;
        flex-wrap: wrap;
        gap: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');

        i {
            font-style: normal;
            font-size: 0.875rem;
            align-self: center;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .zoho-manuals-wrapper {
        .descriptions {
            grid-area: 2 / 1 / 3 / 4;
        }

        .manuals {
            grid-area: 4 / 1 / 3 / 4;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .zoho-manuals-wrapper {
        grid-template-columns: 400px 1fr;

        .descriptions {
            grid-area: 2 / 1 / 3 / 2;
        }

        .manuals {
            grid-area: 2 / 2 / 3 / 4;
        }
    }
}
</style>
